import { dehydrate, QueryClient } from "@tanstack/react-query";
import { GetStaticProps, NextPage } from "next";

import DefaultLayout from "@/components/layouts/DefaultLayout";
import BlogList from "@/components/views/Blog/Articles";
import { getBlogPosts } from "@/services/DefaultService";
import SinglePageService from "@/services/SinglePageService";

const Index: NextPage<{ blogHome: any; initialData: FindResponse<any> }> = ({
  blogHome,
  initialData,
}) => {
  return (
    <DefaultLayout seo={blogHome.attributes.seo}>
      <BlogList blogHome={blogHome} initialData={initialData} />
    </DefaultLayout>
  );
};

export const getStaticProps: GetStaticProps = async (context) => {
  try {
    const blogHome = await SinglePageService.getPage({
      contentType: "blog-home",
      populate: "*",
    });
    const queryClient = new QueryClient();
    const pagination = {
      page: 1,
      pageSize: 10,
    };
    const sort = ["createdAt:desc"];
    const data = await queryClient.fetchQuery(
      ["getBlogPosts", pagination, sort],
      () =>
        getBlogPosts({
          key: "getBlogPosts",
          pagination,
          sort,
        })
    );

    return {
      props: {
        dehydratedState: dehydrate(queryClient),
        blogHome,
        initialData: data,
      },
    };
  } catch (err) {
    return {
      props: {
        blogHome: null,
        initialData: null,
      },
    };
  }
};

export default Index;
